import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DatePicker, Button } from 'antd';
import Select from 'react-virtualized-select';

import { MASCARA_DDMMYYYY,
    esDataFiPeriodeDeshabilitat,
    esDataIniciPeriodeDeshabilitat,
    convertirTextAMomentUTC } from '../../commons/gestioDates';
import PopoverError from '../commons/popoverError';
import { estacioIntroduccioAfegirObservadorHistoric } from '../../actions/estacio';
import { selectorObtenirUsuarisObservadors } from '../../selectors/selector_usuari';

class EstacioIntroduccioHistoricObservadorsAfegir extends Component {

    constructor(props) {
        super(props);

        this.afegirObservador = this.afegirObservador.bind(this);

        this.initialState = {
            nouObservador: {},
            errors: {
                dataAlta: false,
                dataBaixa: false,
                idUsuari: false
            },
        };

        //Inicialitzar amb l'objecte nouObservador
        this.state = this.initialState;
    }

    componentWillReceiveProps() {
        //Això es bàsicament per netejar els elements que inserten observadors
        this.setState(() => this.initialState);
    }

    afegirObservador() {
        let conteErrors = false;    //Al ser asincron el setState() s'ha d'utilitzar un flag
        const { nouObservador } = this.state;
        const { idUsuari, dataAlta, dataBaixa } = nouObservador;
        const { dataBaixaEstacioText, estacioIntroduccioAfegirObservadorHistoric } = this.props;

        //Son obligatoris la data d'alta i el observador
        if (typeof idUsuari === 'undefined' || idUsuari === null) {
            this.setState((prevState) => (
                {
                    errors: {
                        ...prevState.errors,
                        idUsuari: true
                    }
                }
            ));

            conteErrors = true;
        }

        //La data d'alta es obligatoria
        if (!dataAlta) {
            this.setState((prevState) => (
                {
                    errors: {
                        ...prevState.errors,
                        dataAlta: true
                    }
                }
            ));

            conteErrors = true;
        }

        //La data d'alta es obligatoria
        if (dataBaixaEstacioText && !dataBaixa) {
            this.setState((prevState) => (
                {
                    errors: {
                        ...prevState.errors,
                        dataBaixa: true
                    }
                }
            ));

            conteErrors = true;
        }

        if (conteErrors) return;

        //Si existeix data alta i idUsuari es pot afegir un observador
        estacioIntroduccioAfegirObservadorHistoric(nouObservador);
    }

    onModificarDataAlta(dataAlta) {
        if (dataAlta && typeof dataAlta !== 'undefined') {
            dataAlta.startOf('day');
        }

        this.setState((prevState) => (
            {
                nouObservador: {
                    ...prevState.nouObservador,
                    dataAlta
                },
                errors: {
                    ...prevState.errors,
                    dataAlta: false
                }
            })
        );
    }

    onModificarDataBaixa(dataBaixa) {
        if (dataBaixa & typeof dataBaixa !== 'undefined') {
            dataBaixa.startOf('day');
        }

        this.setState((prevState) => (
            {
                ...prevState.errors,
                nouObservador: {
                    ...prevState.nouObservador,
                    dataBaixa
                }
            })
        );
    }

    onChangeObservador(idUsuari) {
        this.setState((prevState) => (
            {
                nouObservador: {
                    ...prevState.nouObservador,
                    idUsuari
                },
                errors: {
                    ...prevState.errors,
                    idUsuari: false
                }
            })
        );
    }

    generarOpcionsObservadors(observadors) {
        if (!observadors) return;

        return observadors.map(observador => {
            const { nom, cognom1, cognom2 } = observador;
            return {
                value: observador.id,
                label: [nom, cognom1, cognom2].filter(Boolean).join(' '),
                className: 'Select-outer-item'
            };
        });
    }

    renderErrorsDataBaixa() {
        const textTooltip = 'Camp obligatori si l\'estació està donada de baixa';
        return (this.state.errors.dataBaixa) ?
            <PopoverError contingut={textTooltip} classNameIcona='icona-error' /> :
            null;
    }

    renderErrorsDataAlta() {
        return (this.state.errors.dataAlta) ?
            <PopoverError contingut='Camp obligatori' classNameIcona='icona-error' /> :
            null;
    }

    renderErrorsObservador() {
        return (this.state.errors.idUsuari) ?
            <PopoverError contingut='Camp obligatori' classNameIcona='icona-error' /> :
            null;
    }

    deshabilitarDataAlta(dataCalendari) {
        const dataActual = convertirTextAMomentUTC(this.props.dataActualText);

        return esDataIniciPeriodeDeshabilitat(dataCalendari, dataActual, this.state.nouObservador.dataBaixa, 'days');
    }

    deshabilitarDataBaixa(dataCalendari) {
        const dataActual = convertirTextAMomentUTC(this.props.dataActualText);
        return esDataFiPeriodeDeshabilitat(dataCalendari, dataActual, this.state.nouObservador.dataAlta, 'days');
    }

    render() {
        const { observadors } = this.props;

        const mostrarErrorDataBaixa = this.renderErrorsDataBaixa();
        const mostrarErrorDataAlta = this.renderErrorsDataAlta();
        const mostrarErrorObservador = this.renderErrorsObservador();

        return (
            <div className='estacio-introduccio-historic-observadors-afegir'>
                <div>
                    <Select
                        options={this.generarOpcionsObservadors(observadors)}
                        simpleValue
                        noResultsText='Observador no trobat'
                        className='selector'
                        placeholder='Selecciona un observador'
                        value={this.state.nouObservador.idUsuari}
                        clearable={false}
                        onChange={(value) => this.onChangeObservador(value)}
                        maxHeight={100}>
                    </Select>
                    {mostrarErrorObservador}
                </div>
                <div>
                    <DatePicker
                        format={MASCARA_DDMMYYYY}
                        className='datepicker'
                        placeholder="Data alta"
                        onChange={(novaData) => this.onModificarDataAlta(novaData)}
                        value={this.state.nouObservador.dataAlta}
                        disabledDate={(data) => this.deshabilitarDataAlta(data)}
                    />
                    {mostrarErrorDataAlta}
                </div>
                <div>
                    <DatePicker
                        format={MASCARA_DDMMYYYY}
                        className='datepicker'
                        placeholder='Data baixa'
                        onChange={(novaData) => this.onModificarDataBaixa(novaData)}
                        value={this.state.nouObservador.dataBaixa}
                        disabledDate={(data) => this.deshabilitarDataBaixa(data)}
                    />
                    {mostrarErrorDataBaixa}
                </div>
                <Button
                    type="primary"
                    icon="plus"
                    shape='circle'
                    onClick={() => this.afegirObservador()}
                />
            </div>
        );
    }
}

EstacioIntroduccioHistoricObservadorsAfegir.propTypes = {
    dataActualText: PropTypes.string.isRequired,
    observadors: PropTypes.array,
    estacioIntroduccioAfegirObservadorHistoric: PropTypes.func,
    dataBaixaEstacioText: PropTypes.string
};

const mapDispatchToProps = {
    estacioIntroduccioAfegirObservadorHistoric
};

const mapStateToProps = (state) => {

    return {
        observadors: selectorObtenirUsuarisObservadors(state),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EstacioIntroduccioHistoricObservadorsAfegir);



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioHistoricObservadorsAfegir.js